<template>
  <div class="superuser-edit-json main">
    <div class="wrapper">
      <p class="header" @click="close">
        <i
          class="fa fa-chevron-left"
          style="padding: 0 4px; margin-right: 4px"
        />
        <span v-if="type === 'business'">Business JSON</span>
        <span v-if="type === 'commerce'">Commerce JSON</span>
        <span v-if="type === 'manifest'">Manifest JSON</span>
        <!-- <span class="is-pulled-right">Edit Workflow</span> -->
      </p>

      <div class="field">
        <div class="control">
          <textarea
            class="textarea is-light has-text-weight-medium no-scrollbar"
            :style="jsonStyle"
            v-model="dataJSON"
            placeholder="Data JSON"
            rows="100"
          ></textarea>
        </div>
      </div>

      <div class="field is-grouped" style="margin: 10px">
        <p class="control">
          <button
            class="button is-outlined has-text-grey"
            :class="{ 'is-danger': invalidJSON }"
            @click="parseJSON"
          >
            <span class="icon" style="margin-right: 4px">
              <i class="fa fa-pencil-alt fa-sm" /> </span
            >Parse
          </button>
        </p>
        <p class="control is-expanded">
          <button
            class="button is-success is-outlined is-fullwidth"
            @click="submit"
          >
            <i class="fa fa-save" />&nbsp;{{ $t("save") }}
          </button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SuperuserEditJSON",
  components: {},
  props: {
    obj: Object,
    type: String, // business, commerce, manifest
  },
  data() {
    return {
      w: {
        name: "",
      },
      dataJSON: null,
      invalidJSON: false,
    };
  },
  computed: {
    jsonStyle() {
      if (this.invalidJSON) return "color:lightpink";
      if (this.type === "business") return "color:lightgreen";
      return "color:#CCCC00";
    },
    businessID() {
      return this.$store.state.selectedBusiness.id;
    },
  },
  mounted() {
    // this.w = this.workflow;
    this.dataJSON = JSON.stringify(this.obj.data, null, 2);
  },
  methods: {
    close() {
      this.$emit("close");
    },
    prettyJSON(str) {
      return JSON.stringify(JSON.parse(str), null, 2);
    },
    isValidJSON() {
      try {
        JSON.parse(this.dataJSON);
      } catch (e) {
        this.invalidJSON = true;
        this.errorToast("Invalid JSON", "top");
        return false;
      }
      this.invalidJSON = false;
      this.infoToast("Valid JSON", "top");
      return true;
    },
    parseJSON() {
      var loader = this.loadingDots("lightgreen");
      if (this.isValidJSON()) {
        this.dataJSON = this.prettyJSON(this.dataJSON);
      }
      setTimeout(() => loader.hide(), 200);
    },
    submit() {
      this.parseJSON();
      if (this.invalidJSON) {
        var msg = `Invalid JSON<br><br>Check keys are quoted<br>and comma-separated`;
        return this.errorToast(msg, "top");
      }
      switch (this.type) {
        case "business":
          return this.submitBusinessJSON();
        case "commerce":
          return this.submitWorkflowJSON();
        default:
          this.errorToast("Invalid type: " + this.type);
      }
    },
    submitBusinessJSON() {
      var loader = this.loadingDots("gold");
      this.$store
        .dispatch("updateBusiness", {
          id: this.obj.id,
          data: JSON.parse(this.dataJSON),
        })
        .then(() => this.getUpdatedBusiness())
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    submitWorkflowJSON() {
      var loader = this.loadingDots("lightgreen");
      this.$store
        .dispatch("updateWorkflow", {
          id: this.obj.id,
          business_id: this.obj.business_id, //this.businessID,
          // name: this.w.name,
          data: JSON.parse(this.dataJSON),
        })
        .then(() => this.getUpdatedBusiness())
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    getUpdatedBusiness() {
      var loader = this.loadingDots("lightyellow");
      this.$store
        .dispatch("getAndSelectBusiness", this.businessID)
        .then(() => this.getUpdatedWorkflows())
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    getUpdatedWorkflows() {
      var loader = this.loadingDots("lightyellow");
      this.$store
        .dispatch("getWorkflows", this.businessID)
        .then(() => {
          this.close();
          this.refreshPage();
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: whitesmoke;
  z-index: 21;
  overflow: hidden;
}
.wrapper {
  /* padding: 10px; */
  text-align: left;
  height: 100vh;
  overflow: hidden;
}
.field {
  margin-bottom: 6px;
}
textarea {
  border-radius: 0px;
  max-height: calc(100vh - 110px);
  background-color: rgb(73, 84, 95);
  /* background-color: #1f1a24; */
}
.header {
  padding: 10px;
  text-align: left;
  font-size: 1.3em;
  font-weight: 500;
  /* padding-left: 8px; */
  /* margin-bottom: 10px; */
}
.header span {
  color: black;
  opacity: 0.5;
  font-size: 0.9em;
}
</style>